import { BreadCrumbJsonLdProps } from "next-seo";
import { useMemo } from "react";
import { BreadcrumbSegment, BreadcrumbTrail } from "@/types/breadcrumbs";
import { generateBreadcrumbs } from "@/utils/breadcrumbs";

export const useBreadcrumbs = (
  breadcrumbs: BreadcrumbSegment[]
): {
  trail: BreadcrumbTrail;
  itemListElements: BreadCrumbJsonLdProps["itemListElements"];
} => {
  return useMemo(() => {
    return generateBreadcrumbs(breadcrumbs);
  }, [breadcrumbs]);
};
